// extracted by mini-css-extract-plugin
export var arrowDownForPickems = "MatchCard-module--arrowDownForPickems--61cb0";
export var arrowIcon = "MatchCard-module--arrowIcon--b75f9";
export var arrowUpForPickems = "MatchCard-module--arrowUpForPickems--7d7f9";
export var blue = "#0eb3f2";
export var clampRight = "MatchCard-module--clampRight--73c92";
export var className = "MatchCard-module--className--07fd8";
export var cluster = "MatchCard-module--cluster--ed521";
export var clusterRow = "MatchCard-module--clusterRow--a5c31";
export var competitorIcon = "MatchCard-module--competitorIcon--5edb8";
export var disabled = "MatchCard-module--disabled--bcf57";
export var draw = "MatchCard-module--draw--7ea36";
export var emphasis = "MatchCard-module--emphasis--f4484";
export var enter = "MatchCard-module--enter--4c529";
export var green = "#57d33b";
export var greenLink = "MatchCard-module--green-link--cc7a7";
export var grey = "var(--tone-mid)";
export var hasDraw = "MatchCard-module--hasDraw--ec203";
export var header = "MatchCard-module--header--cfccd";
export var highlighted = "MatchCard-module--highlighted--771d9";
export var icon = "MatchCard-module--icon--451e3";
export var lockIcon = "MatchCard-module--lockIcon--dfc71";
export var lostOrVoid = "MatchCard-module--lostOrVoid--32d51";
export var marketsClamp = "MatchCard-module--marketsClamp--a1913";
export var matchCard = "MatchCard-module--matchCard--1ab17";
export var matchMode = "MatchCard-module--matchMode--b3bb8";
export var name = "MatchCard-module--name--50dd0";
export var nameAndOdds = "MatchCard-module--nameAndOdds--072bc";
export var normalCursor = "MatchCard-module--normalCursor--e24f2";
export var notchGap = "32px";
export var odds = "MatchCard-module--odds--a0fcb";
export var oddsChangeArrowDown = "MatchCard-module--oddsChangeArrowDown--1376f";
export var oddsChangeArrowUp = "MatchCard-module--oddsChangeArrowUp--5f54d";
export var oddsWrapper = "MatchCard-module--oddsWrapper--b34c5";
export var orange = "#f8662b";
export var outcome = "MatchCard-module--outcome--0d149";
export var outcomes = "MatchCard-module--outcomes--229f5";
export var promoIcon = "MatchCard-module--promoIcon--3e1c3";
export var red = "#ff2741";
export var selected = "MatchCard-module--selected--6f0df";
export var sgmAndMarkets = "MatchCard-module--sgmAndMarkets--d9fe0";
export var sgmButton = "MatchCard-module--sgmButton--b5c12";
export var small = "MatchCard-module--small--3c935";
export var subtitle = "MatchCard-module--subtitle--a07af";
export var title = "MatchCard-module--title--a27db";
export var titleIcon = "MatchCard-module--titleIcon--27480";
export var titleWrapper = "MatchCard-module--titleWrapper--c5bcd";
export var versusDivider = "MatchCard-module--versusDivider--5cf75";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var won = "MatchCard-module--won--b8c4c";
export var yellow = "#ffb100";